module.exports = __webpack_public_path__ + "static/media/medical_cert_p3_1.5c0d51dd.png";